import React, { ReactElement } from 'react'
import KMWLogo from './kurz-mal-weg-de.svg'

export default function KMWLabel(): ReactElement {
  return (
    <div className="absolute -bottom-[1px] left-0 z-10 w-auto bg-white pb-1 pl-2 pr-2 pt-1">
      <KMWLogo className="w-24" />
    </div>
  )
}
